import * as _ from 'lodash';
import { Component, AfterViewInit, OnDestroy, Renderer2, ChangeDetectorRef, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import * as firebase from 'firebase';

import { AuthService } from './service/auth.service';
import { NotificationService } from './service/notification.service';
import { MessageService } from 'primeng/api';
import { UserProfile } from './model/userProfile.model';
import { UserProfileService } from './service/user-profile.service';
import { SwUpdate } from '@angular/service-worker';
import { CommonService } from './service/common.service';

enum MenuOrientation {
    STATIC,
    OVERLAY
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss',
    '../../node_modules/primeflex/primeflex.css']
})

export class AppComponent implements AfterViewInit, OnDestroy, OnInit {

    bgImage = '/assets/images/bg/pipeline_blur.png';

    activeTabIndex = -1;

    sidebarActive = false;

    layoutMode: MenuOrientation = MenuOrientation.OVERLAY;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    rotateMenuButton: boolean;

    sidebarClick: boolean;

    topbarItemClick: boolean;

    menuButtonClick: boolean;

    isLoggedIn: boolean;

    activeTopbarItem: any;

    documentClickListener: Function;

    theme = 'bluegrey';

    avatarUrl = '';
    searchString: string;

    toggleMyStuff: boolean;
    toggleMyFavorites: boolean;

    userInviteCount: number;
    invites: any[] = [];

    userMessageCount: number;
    currentDate: Date;

    constructor(
        private swUpdate: SwUpdate,
        public renderer: Renderer2,
        private router: Router,
        private cdRef: ChangeDetectorRef,
        public authService: AuthService,
        public userProfileService: UserProfileService,
        public commonService: CommonService
    ) {
        this.checkUserAuthStatus();
    }

    ngOnInit() {
        this.currentDate = new Date();

        // if new version exists and has been loaded, ask any active user to accept a refresh
        // https://blog.angular-university.io/angular-service-worker/
        if (this.swUpdate.isEnabled) {

            this.swUpdate.available.subscribe(() => {

                if (confirm('New version available. Load New Version?')) {

                    window.location.reload();
                }
            });
        }
    }

    ngAfterViewInit() {
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.menuButtonClick && !this.sidebarClick && (this.overlay || !this.isDesktop())) {
                this.sidebarActive = false;
            }

            this.topbarItemClick = false;
            this.sidebarClick = false;
            this.menuButtonClick = false;
        });
    }

    onTabClick(event: Event, index: number) {
        if (this.activeTabIndex === index) {
            this.sidebarActive = !this.sidebarActive;
        } else {
            this.activeTabIndex = index;
            this.sidebarActive = true;
        }

        event.preventDefault();
    }

    closeSidebar(event: Event) {
        this.sidebarActive = false;
        event.preventDefault();
    }

    onSidebarClick(event: Event) {
        this.sidebarClick = true;
    }

    onTopbarMenuButtonClick(event: Event) {
        // this.staticMenuDesktopInactive = true;
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;

        event.preventDefault();
    }

    onTopbarItemClick(event: Event, item) {
        this.topbarItemClick = true;
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarLoginItemClick(event: Event) {
        this.topbarItemClick = true;
        this.router.navigate(['login']);
        event.preventDefault();
    }

    onTopbarRegisterItemClick(event: Event) {
        this.topbarItemClick = true;
        this.router.navigate(['signup']);
        event.preventDefault();
    }

    onTopbarLogoutItemClick(event: Event) {
        this.topbarItemClick = true;

        this.authService.doLogout()
            .then(res => {
                this.authService.setCurrentUser(null);
                this.avatarUrl = '';
                this.isLoggedIn = false;
                this.router.navigate(['/']);
                // window.location.reload();
            }, err => {
            });

        this.router.navigate(['/']);
        event.preventDefault();
    }

    get overlay(): boolean {
        return this.layoutMode === MenuOrientation.OVERLAY;
    }

    changeToStaticMenu() {
        this.layoutMode = MenuOrientation.STATIC;
    }

    changeToOverlayMenu() {
        this.layoutMode = MenuOrientation.OVERLAY;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }

    checkUserAuthStatus() {
        firebase.auth().onAuthStateChanged((user: firebase.User) => {
            if (user) {
                this.authService.setCurrentUser(user);
                this.avatarUrl = user.photoURL;
                this.isLoggedIn = true;
                this.userProfileService.getUserProfile(user.uid)
                    .then((userProfile: UserProfile) => {
                        this.userProfileService.userProfile = userProfile;
                    });
            }
            this.cdRef.detectChanges(); // needed because onAuthStateChanged is not triggering angular change detection
        });
    }

    processInvite(invite) {
        this.router.navigate(['userinvites']);
    }
}
